import i18n from '@/utils/i18n';
import React from 'react';
import { OrderEntryMobileCardSkeleton } from '@/experiences/sales-portal/domain/ordering/screens/order-entry/components/order-entry-mobile-card-skeleton';
import { useTheme } from '@/contexts/theme-context';
import { YStack } from '@usepepper/sprout-kit-ui';

const SKELETON_CARD_COUNT = 8;

export const OrderEntryMobileSkeletonList: React.FC = () => {
  const theme = useTheme();
  return (
    <YStack
      accessibilityLabel={i18n.t('sales_portal.order_entry')}
      accessibilityRole="progressbar"
      accessibilityState={{ busy: true }}
      accessible
      gap={theme.sk.spacing.spaceSMedium}
    >
      {Array.from({ length: SKELETON_CARD_COUNT }).map((_, index) => (
        <OrderEntryMobileCardSkeleton key={index} />
      ))}
    </YStack>
  );
};
